import { render, staticRenderFns } from "./newPassword.vue?vue&type=template&id=174009f8&scoped=true"
import script from "./newPassword.vue?vue&type=script&lang=js"
export * from "./newPassword.vue?vue&type=script&lang=js"
import style0 from "./newPassword.vue?vue&type=style&index=0&id=174009f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174009f8",
  null
  
)

export default component.exports